let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aDKtW")).then(() => parcelRequire('dmwrO'));